import { AuthTokenHeader, FetchClient } from '@vp/fetch-client';
import { ILogger } from '@vp/pdp-ubik-logging';

import { getStock } from '../../infrastructure/clients/client-side/maiseClient';

export const isOutOfStock = async (
  tenant: string,
  locale: string,
  productKey: string,
  productVersion: number,
  authorizationHeader: AuthTokenHeader,
  logger: ILogger
): Promise<boolean> => {
  const country = extractCountry(locale);
  const fetchClient = new FetchClient(logger);

  const stock = await getStock(
    tenant,
    country,
    productKey,
    productVersion,
    {},
    authorizationHeader,
    fetchClient
  );

  if (stock.isFailed) return false;

  return (
    !stock.result.availabilityState.statusStates.IsMerchandisable ||
    !stock.result.availabilityState.statusStates.IsDeliverable ||
    stock.result.availabilityState.statusStates.IsRetiredforMerchandising ||
    (stock.result.availabilityState.inventoryCount != undefined &&
      stock.result.availabilityState.inventoryCount <= 0)
  );
};

const extractCountry = (localeString: string): string => {
  const locale = new Intl.Locale(localeString);
  if (!locale.region) throw new Error(`Invalid locale ${localeString}. Country code is missing`);
  return locale.region;
};
